import {Routes} from '@angular/router';
import {privateRoutes} from './private/private-routing';
import {authRoutes} from './auth/auth-routing';

export const routes: Routes = [
  {path: 'private', children: privateRoutes},
  {path: 'auth', children: authRoutes},
  {path: '', redirectTo: '/private', pathMatch: 'full'},
];
